<template>
  <div class="wap_attract">
    <div class="wap_attractul" id="wap_wiewer">
      <div
        @click="waplookAttract(index)"
        class="wap_attract_li"
        v-for="(item, index) in attractList"
        :key="index"
      >
        <div
          class="wap_attract_li_img"
          :class="item.show ? 'wap_attract_li_imgs' : ''"
        >
          <img :data-original="item.url" :src="item.url" />
          <div class="wap_attract_li_close"></div>
        </div>
        <div class="wap_attract_li_shadow"></div>
      </div>
    </div>
    <!-- 无权限提示 -->
    <transition enter-active-class="animate__animated animate__fadeInDown">
      <div v-if="jurisdiction" class="jurisdiction">暂无权限打开</div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jurisdiction: false,
      wapViewer: null, //图片预览实例
      attractList: [
        {
          url: require("../../assets/images/accredit.jpg"),
          show: true,
          background:
            "url('../../assets/images/accredit.jpg') no-repeat center",
        },
        {
          url: require("../../assets/images/1.png"),
          show: false,
          background: "url('../../assets/images/1.png') no-repeat center",
        },
        {
          url: require("../../assets/images/2.png"),
          show: false,
          background: "url('../../assets/images/2.png') no-repeat center",
        },
        {
          url: require("../../assets/images/3.jpg"),
          show: false,
          background: "url('../../assets/images/3.jpg') no-repeat center",
        },
        // {
        // 	url: "./images/4.png",
        // 	show: false,
        // 	background: "url('./images/4.png') no-repeat center"

        // }
      ],
    };
  },
  created() {},
  mounted() {
    this.wapantishake = this.debounce(this.lookAttractF);
    this.$nextTick(() => {
      this.viewerInit();
    });
  },
  methods: {
    lookAttractF() {
      setTimeout(() => {
        this.jurisdiction = false;
      }, 1000);
    },
    debounce(fun, wait = 1000) {
      let timeout = null;
      return function () {
        if (timeout) {
          //如果存在定时器就清空
          clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
          fun.apply(this, arguments);
        }, wait);
      };
    },
    // 初始化图片预览
    viewerInit() {
      let wap_wiewer = document.querySelector("#wap_wiewer");
      this.wapViewer = new Viewer(wap_wiewer, {
        url: "data-original",
        toolbar: true,
        movable: true,
        title: false,
      });
    },
    waplookAttract(index) {
      this.attractList.forEach((item) => {
        item.show = false;
      });
      this.attractList[index].show = true;
      this.wapViewer.index = index;
      this.wapViewer.show();
    },
  },
};
</script>

<style scoped lang="scss">
.jurisdiction {
  position: fixed;
  top: 1.25rem /* 100/80 */;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 99999999;
  padding: 0.25rem /* 20/80 */;
  border-radius: 0.125rem /* 10/80 */;
  color: #000;
  background: #fff;
  font-size: 0.2rem /* 16/80 */;
  width: 2.5rem /* 200/80 */;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0.05rem /* 4/80 */ 0.15rem /* 12/80 */;
}
.wap_attract {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/web/two_bg.png") no-repeat center;
  background-size: cover;
}
.wap_attractul {
  margin: 0 auto;
  padding-top: 2.666667rem /* 100/37.5 */;
  width: 90%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.wap_attract .wap_attractul > div {
  width: 4.186667rem /* 157/37.5 */;
  // width: 50%;
  height: 5.6rem /* 210/37.5 */;
  background: url("../../assets/images/frame.png") center;
  background-size: contain;
  margin-bottom: 1.653333rem /* 62/37.5 */;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wap_attract_li {
  position: relative;
}
.wap_attract .wap_attractul > div .wap_attract_li_img {
  position: relative;
  /* top: -1px; */
  display: block;
  width: 2.986667rem /* 112/37.5 */;
  height: 4.213333rem /* 158/37.5 */;
}
.wap_attract_li_img img {
  display: block;
  width: 100%;
  height: 100%;
}
.wap_attract_li_imgs::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 99%;
  background: #000;
  opacity: 0.45;
}
.wap_attract_li_close {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: translateY(-50%);
  z-index: 2;
  width: 0.906667rem /* 34/37.5 */;
  height: 0.906667rem /* 34/37.5 */;
  background: url("../../assets/images/magnify.png") no-repeat center;
  background-size: cover;
}
.wap_attract_li_shadow {
  position: absolute;
  background: #000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/frame1.png") no-repeat center;
  background-size: contain;
  opacity: 0.45;
}
@media (max-width: 750px) and (max-height: 600px) {
  .wap_attractul {
    padding-top: 2.133333rem /* 80/37.5 */;
  }
  .wap_attract .wap_attractul > div {
    margin-bottom: 0;
    height: 5.333333rem /* 200/37.5 */;
  }
}
</style>
